module.exports = __webpack_public_path__ + "static/media/21.9a47f7b0.jpg";